import React, { useState } from "react";
import Checkbox from "../Checkbox";
import Accordion from "../Accordion";
import OutputFactory from "../OutputFactory";
import CollapseView from "./CollapseView";
import AccordionProvider from "../Accordion/AccordionProvider";
import AccordionCollapse from "../Accordion/AccordionCollapse";
import htmlId from "../htmlId";

let timeoutId;

function Body({
  objects,
  fields,
  columns,
  excludes,
  selected,
  selectable,
  onSelect,
  onClick,
  onLongPress,
  actionsList,
  collapsable,
  onCollapse,
  toggleable,
  actions,
  onClickItem,
  fieldImage,
}) {
  const [collapsedRows, setCollapsedRows] = useState([]);

  const onPointerDown = () => {
    timeoutId = setTimeout(onLongPress, 500); // long press = 500ms
  };

  const onPointerUp = () => {
    clearTimeout(timeoutId);
  };

  const toggleCollapse = (index) => {
    setCollapsedRows((prev) =>
      prev.includes(index)
        ? prev.filter((i) => i !== index)
        : [...prev, index]
    );
  };

  return objects.map((object, index) => {
    const id = htmlId(object.id || object._id || index);
    const checked = selected.includes(object);
    const isCollapsed = collapsedRows.includes(index);

    return (
      <AccordionProvider key={id}>
        <tr
          style={{ cursor: "pointer" }}
          onClick={() => {
            onClick && onClick(object, index);
            toggleCollapse(index);
          }}
        >
          {selectable && (
            <th className="align-middle">
              <Checkbox
                checked={checked}
                id={"check_" + id}
                onChange={() => onSelect(index)}
              />
            </th>
          )}

          {columns.map((field) => {
            const options = fields[field];
            if (excludes.includes(field)) return null;
            return (
              <Accordion
                as="td"
                eventKey={`_${id}`}
                key={field}
                className="fs-sm text-truncate"
                onPointerDown={onPointerDown}
                onPointerUp={onPointerUp}
                style={{ cursor: "pointer", maxWidth: "15em" }}
              >
                <OutputFactory field={field} object={object} {...options} />
              </Accordion>
            );
          })}

          {actionsList.length > 0 && (
            <td>
              <div style={{ width: "50px" }}></div>
            </td>
          )}

          {actionsList.map((action) => (
            <td className="text-truncate" key={action.label}>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  action.onClick && action.onClick(index);
                }}
                className="btn btn-outline-primary btn-sm fs-xs shadow-none"
              >
                <i className={action.icon} /> {action.label}
              </button>
            </td>
          ))}
            {collapsable && (
                <Accordion
                    as="td"
                    eventKey={`_${id}`}
                    className="pe-2"
                    onClick={(e) => {
                    e.stopPropagation(); // prevent row click
                    toggleCollapse(index); // visual toggle for icon
                    }}
                    style={{
                    cursor: "pointer",
                    width: "30px"
                    }}
                >
                    <i
                    className={isCollapsed ? "bi bi-chevron-up" : "bi bi-chevron-down"}
                    style={{ color: "#283754" }}
                    />
                </Accordion>
                )}
        </tr>

        {collapsable && (
          <tr>
            <td className="p-0" colSpan={columns.length + (selectable ? 2 : 1)}>
              <AccordionCollapse
                toggleable={toggleable}
                className="collapse p-3"
                eventKey={`_${id}`}
              >
                {onCollapse(index, object, excludes) ||
                  CollapseView(
                    index,
                    object,
                    excludes,
                    fields,
                    actions,
                    onClickItem,
                    fieldImage
                  )}
              </AccordionCollapse>
            </td>
          </tr>
        )}
      </AccordionProvider>
    );
  });
}

export default Body;
